import { IMAGES } from "@/lib/site-data";
import { Calendar, ArrowRight } from "lucide-react";

const posts = [
  {
    title: "How Indian Onions Reach Your Table",
    date: "Jan 12, 2025",
    excerpt: "A behind-the-scenes look at our journey from farm to global markets.",
    image: IMAGES.onionsHero,
  },
  {
    title: "Why Nashik Onions Are Loved Worldwide",
    date: "Feb 3, 2025",
    excerpt: "Discover what makes Nashik onions the preferred choice for importers.",
    image: IMAGES.onionBasket,
  },
  {
    title: "Sustainable Packing Practices",
    date: "Feb 20, 2025",
    excerpt: "Our commitment to hygienic, eco-friendly packing solutions.",
    image: IMAGES.onionsRedPile,
  },
];

export default function Blog() {
  return (
    <div>
      <section className="bg-sky-50/60 py-14">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-sm font-semibold tracking-widest text-[#1e5ba8]">BLOG</p>
          <h1 className="font-display font-bold text-5xl sm:text-6xl text-[#0f172a] mt-3 tracking-tight">Insights & Updates</h1>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {posts.map((p) => (
            <article key={p.title} className="bg-white border border-slate-200 rounded-xl overflow-hidden hover:-translate-y-1 hover:shadow-lg transition-transform duration-200">
              <img src={p.image} alt={p.title} className="w-full h-48 object-cover" />
              <div className="p-5">
                <div className="flex items-center gap-1.5 text-xs text-slate-500">
                  <Calendar className="w-3.5 h-3.5" /> {p.date}
                </div>
                <h3 className="font-display font-bold text-lg mt-2 leading-snug">{p.title}</h3>
                <p className="text-sm text-slate-600 mt-2">{p.excerpt}</p>
                <a href="#" className="inline-flex items-center gap-1 mt-4 text-sm font-semibold text-[#1e5ba8] hover:gap-2 transition-all duration-200">
                  Read More <ArrowRight className="w-4 h-4" />
                </a>
              </div>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
}
